















































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Swiper } from '@/components';
import SearchingPanel from '@/components/SearchingPanel';
import InformationCard from '@/components/InformationCard';
import BannerWithSlot from '@/components/BannerWithSlot';
import Title from '@/components/Title';
import GoogleMapLoader from '@/components/GoogleMapLoader';
import GoogleMapMarker from '@/components/GoogleMapMarker';
import {mapGetters, mapActions} from 'vuex';
import { arrayIsEmpty } from '@/utils';
import Marker = google.maps.Marker;
import {objectToQuerystring} from '@/services/api';
interface VueMarker extends Vue, Marker {}

@Component({
  name: 'AboutComplex',
  components: {
    BannerWithSlot, GoogleMapLoader, GoogleMapMarker,
    InformationCard, SearchingPanel, Swiper, Title,
  },
  created(): void {
    this.actualQuery = this.actualSearchData;
  },
  data() {
    return {
      swiperOption: {
        height: 220,
        loop: true,
        navigation: {
          class: 'nav-icon',
        },
        pagination: false,
      },
      show: true,
      actualQuery: {},
      advantagesIcons: [
        '$vuetify.icons.metro-orange',
        '$vuetify.icons.tech-orange',
        '$vuetify.icons.heat-orange',
        '$vuetify.icons.security-orange',
      ],
      topIcons: [
        '$vuetify.icons.car-orange',
        '$vuetify.icons.dentist-orange',
        '$vuetify.icons.cafe-orange',
        '$vuetify.icons.eat-orange',
      ],
      cafes: {
        icon: 'cafes',
        items: [
        { lat: 50.3822326, lng: 30.4779136 },
        { lat: 50.382096, lng: 30.47836 },
        { lat: 50.3828151, lng: 30.47911089999999 },
        { lat: 50.38118720000001, lng: 30.476111 },
        { lat: 50.3809784, lng: 30.4763201 },
        { lat: 50.3819572, lng: 30.4773018 },
        { lat: 50.3829723, lng: 30.47881 },
        { lat: 50.3811796, lng: 30.476424 },

        { lat: 50.3809297, lng: 30.4799151 },
        { lat: 50.3793685, lng: 30.4786834 },

        { lat: 50.37965089999999, lng: 30.4808204 },
        { lat: 50.381621, lng: 30.48172300000001 },
        { lat: 50.3821839, lng: 30.4782947 },
        { lat: 50.3821395, lng: 30.4781868 },
        ],
      },
      gyms: {
        icon: 'gyms',
        items: [
        { lat: 50.3826911950339, lng: 30.47908425023934 },
        { lat: 50.3789082, lng: 30.48207 },
        { lat: 50.38843809999999, lng: 30.4743013 },
        { lat: 50.3862166, lng: 30.4648571 },
        { lat: 50.3888879, lng: 30.4785348 },
        ],
      },
      parking: {
        icon: 'parking',
        items: [
          { lat: 50.3809327, lng: 30.4848796 },
          { lat: 50.380307678925384, lng: 30.47657519200584 },
          { lat: 50.3808613915254, lng: 30.475951133694252 },
        ],
      },
      metro: {
        icon: 'metro',
        items: [{ lat: 50.3821018, lng: 30.4771875 }],
      },
      shops: {
        icon: 'shops',
        items: [
          { lat: 50.3827726, lng: 30.4778136 },
          { lat: 50.383201, lng: 30.480996 },
          { lat: 50.38301999999999, lng: 30.479035 },
          { lat: 50.383352, lng: 30.48151 },
          { lat: 50.383574, lng: 30.4819857 },
          { lat: 50.3819313, lng: 30.4778023 },
          { lat: 50.38278099999999, lng: 30.478934 },
          { lat: 50.384333, lng: 30.479679 },
          { lat: 50.382815, lng: 50.382815 },
          { lat: 50.382622, lng: 30.47764110000001 },
          { lat: 50.382096, lng: 30.47836 },
          { lat: 30.47836, lng: 30.47904929999999 },
        ],
      },
      dotType: 'parking',
    };
  },
  computed: {
    ...mapGetters([
      'searchingPanel',
      'actualSearchData',
      'chooseButtonLink',
    ]),
    ...mapGetters('about', [
      'aboutComplexTexts',
    ]),
    actualDots: {
      get() {
        return this[this.dotType];
      },
      set(newDotType) {
        this.dotType = newDotType;
      },
    },
  },
  methods: {
    ...mapActions([
      'updateActualSearchData',
    ]),
    sendToApiSearch(data) {
      this.$set(this, 'actualQuery', {...this.actualQuery, ...data});
      this.updateActualSearchData(this.actualQuery);
      this.$router.push({path: `/catalog/?${objectToQuerystring(this.actualQuery)}`});
    },
    clearMap() {
      for ( const marker of (this.$refs.googleMapBlock as VueMarker[])) {
        marker.mar.setMap(null);
        this.show = false;
      }
    },
    addDotsToMap(items) {
      this.clearMap();
      setTimeout(() => {
        this.actualDots = items;
        this.show = true;
      }, 0);
    },
    isEmptyArray(val) {
      return arrayIsEmpty(val);
    },
  },
})
export default class AboutComplex extends Vue {}
